import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import Signifier from "../../../../../App/Components/Signifier/Signifier";

import DraggableTable from "../../../../../App/Components/Table/DraggableTable";
import FeaturedJobGroupDetailTableCell from "./FeaturedJobGroupDetailTableCell";
import { useFeaturedGroupsDisplayState } from "./State/FeaturedJobGroupDisplayState";
import { CardHeader } from "@mui/material";

function FeaturedJobGroupsDisplayPage() {
  const state = useFeaturedGroupsDisplayState();

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "75%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    card: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const columns = [
    { label: "Selected", propName: "selected" },
    { label: "Property", propName: "detailsPropertyAdminText" },
    { label: "", propName: "" },
  ];

  return (
    <>
      <Signifier
        showSignifier={state.getters.showSignifier}
        setShowSignifier={state.setters.setShowSignifier}
        message={state.getters.responseMessage}
        error={state.getters.showError}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Button
              style={{
                marginTop: "0px",
                marginBottom: "20px",
              }}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => state.handlers.saveFeaturedJobGroupsDisplay()}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={1} className={classes.card}>
          <Card>
            <CardContent>
              <CardHeader title="Display Settings For Featured Groups"></CardHeader>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={state.getters.groupHasNoCountMessage}
                        onChange={() =>
                          state.setters.setGroupHasNoCountMessage(
                            !state.getters.groupHasNoCountMessage
                          )
                        }
                      />
                    }
                    label="Has No Groups Available Message"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={state.getters.groupUseCarousel}
                        onChange={() =>
                          state.setters.setGroupUseCarousel(
                            !state.getters.groupUseCarousel
                          )
                        }
                      />
                    }
                    label="Display Groups As Carousel"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={!state.getters.carouselDisplayVertically}
                        onChange={() =>
                          state.setters.setCarouselDisplayVertically(
                            !state.getters.carouselDisplayVertically
                          )
                        }
                      />
                    }
                    label="Display Groups Carousel Horizontally"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="No Groups Available Message"
                    label="No Groups Available Message"
                    variant="standard"
                    fullWidth
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={state.getters.groupNoCountMessage}
                    onChange={(e) =>
                      state.setters.setGroupNoCountMessage(e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="Amount of Groups Before Carousel Displays"
                    label="Display Groups As Carousel After"
                    variant="standard"
                    fullWidth
                    type="number"
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={state.getters.groupAutomaticCarouselAfter}
                    onChange={(e) =>
                      state.setters.setGroupAutomaticCarouselAfter(
                        e.target.value
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="Amount of Slides In Groups Carousel"
                    label="Slides In Groups Carousel (default: 2)"
                    variant="standard"
                    fullWidth
                    type="number"
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={state.getters.groupCarouselShowCount}
                    onChange={(e) =>
                      state.setters.setGroupCarouselShowCount(e.target.value)
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid container spacing={1} className={classes.card}>
          <Card>
            <CardContent>
              <CardHeader title="Display Settings For Jobs Within A Featured Group"></CardHeader>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={state.getters.jobHasNoCountMessage}
                        onChange={() =>
                          state.setters.setJobHasNoCountMessage(
                            !state.getters.jobHasNoCountMessage
                          )
                        }
                      />
                    }
                    label="Has No Jobs Available Message"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={state.getters.jobUseCarousel}
                        onChange={() =>
                          state.setters.setJobUseCarousel(
                            !state.getters.jobUseCarousel
                          )
                        }
                      />
                    }
                    label="Display Jobs As Carousel"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={!state.getters.jobCarouselDisplayVertically}
                        onChange={() =>
                          state.setters.setJobCarouselDisplayVertically(
                            !state.getters.jobCarouselDisplayVertically
                          )
                        }
                      />
                    }
                    label="Display Jobs Carousel Horizontally"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="No Jobs Available Message"
                    label="No Jobs Available Message"
                    variant="standard"
                    fullWidth
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={state.getters.jobNoCountMessage}
                    onChange={(e) =>
                      state.setters.setJobNoCountMessage(e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="Amount of Jobs Before Carousel Displays"
                    label="Display Jobs As Carousel After"
                    variant="standard"
                    fullWidth
                    type="number"
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={state.getters.jobAutomaticCarouselAfter}
                    onChange={(e) =>
                      state.setters.setJobAutomaticCarouselAfter(e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="Amount of Slides In Jobs Carousel"
                    label="Slides In Jobs Carousel (default: 2)"
                    variant="standard"
                    fullWidth
                    type="number"
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={state.getters.jobCarouselShowCount}
                    onChange={(e) =>
                      state.setters.setJobCarouselShowCount(e.target.value)
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Grid item xs={12} sm={12}></Grid>
          <DraggableTable
            columns={columns}
            tableData={state.getters.properties}
            setTableData={state.setters.setProperties}
            rowComponent={FeaturedJobGroupDetailTableCell}
            loading={state.getters.loading}
          />
        </Grid>
      </div>
    </>
  );
}

export default FeaturedJobGroupsDisplayPage;
